/**
 * Registry of storage providers. Adding a storage strategy = implement `MediaStorageProvider`
 * and register it in `setup.ts`; nothing else in the app needs to change.
 */
import type { MediaStorageProvider } from './types.ts';

export class ProviderRegistry {
  private readonly providers = new Map<string, MediaStorageProvider>();

  constructor(private importProviderId: string) {}

  register(provider: MediaStorageProvider): this {
    if (this.providers.has(provider.id)) throw new Error(`Provider "${provider.id}" is already registered`);
    this.providers.set(provider.id, provider);
    return this;
  }

  get(id: string): MediaStorageProvider | undefined {
    return this.providers.get(id);
  }

  all(): MediaStorageProvider[] {
    return [...this.providers.values()];
  }

  /** The provider new media is imported into. */
  get importProvider(): MediaStorageProvider {
    const provider = this.providers.get(this.importProviderId);
    if (!provider) throw new Error(`Import provider "${this.importProviderId}" is not registered`);
    return provider;
  }

  setImportProvider(id: string): void {
    const provider = this.providers.get(id);
    if (!provider?.canImport) throw new Error(`Provider "${id}" cannot import media`);
    this.importProviderId = id;
  }
}
